import { LocationAnswerType, UuidableName } from 'utils/api/types';

import { EntityModules } from 'core/constants';

export enum IncidentType {
  RedAlert = 'redAlert',
  AmberAlert = 'amberAlert',
}

export enum IncidentStatus {
  Open = 'open',
  Resolved = 'resolved',
  Archived = 'archived',
}

export type TransitionTuple = [string, string];

export type JSONSchemaType = {
  type: string;
  description: string;
  protectorType: string;
  title?: string;
  name?: string;
  maximum?: number;
  minimum?: number;
  items?: {
    enum: string[];
  };
  properties: {
    [key: string]: JSONSchemaType;
  };
  order: string[];
  contentEncoding?: string;
  enum?: string[];
  default?: string;
  protectorSettings?: {
    colors?: {
      [key: string]: {
        foreground: string;
        background: string;
      };
    };
    transitions?: {
      [key: string]: TransitionTuple[];
    };
  };
  required?: string[];
  lookupType?: EntityModules;
  editable?: boolean;
  readonly?: boolean;
  nullable?: boolean;
  roles?: Array<string>;
  helpText?: string | null;
  momentDate?: boolean;
};

export interface SchemaContent {
  schema: JSONSchemaType & { required: string[] };
  content: AnswerType;
}

export interface JSONSchemaValue<T = string | string[] | object> {
  schema: JSONSchemaType;
  value: T;
}

export type AnswerTypes =
  | string
  | string[]
  | number
  | boolean
  | null
  | LocationAnswerType
  | {
      [key: string]: AnswerTypes;
    }
  | UuidableName
  | UuidableName[]
  | AttachmentType[];

export type AttachmentType = {
  filename: string;
  size: number;
  url: string;
};

export type AnswerType = {
  [key: string]: AnswerTypes;
};
